import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionTwo: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="font-Alpro mb-2 text-center  text-[24px] text-blue  lg:text-center lg:text-[32px]">Wie würdest Du Deinen Ernährungsstil beschreiben?*</h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Veganer</>}
					props={{
						type: "radio",
						name: "question2",
						value: "a",
						required: true,
						onClick: e => formElementChanged(e, "question2"),
					}}
					className=" pb-2 text-green"
				/>
				<ElemCheckboxMafo
					label={<>Vegetarisch</>}
					props={{
						type: "radio",
						name: "question2",
						value: "b", required: true,
						onClick: e => formElementChanged(e, "question2"),
					}}
					className="pb-2 text-green"
				/>
				<ElemCheckboxMafo
					label={<>Flexitarisch (ich
						reduziere bewusst
						tierische
						Produkte)  </>}
					props={{
						type: "radio",
						name: "question2",
						value: "c",
						required: true,
						onClick: e => formElementChanged(e, "question2"),
					}}
					className=" pb-2 text-green"
				/>
				<ElemCheckboxMafo
					label={<>Ich verzichte nicht bewusst auf tierische Produkte</>}
					props={{
						type: "radio",
						name: "question2",
						value: "d",
						required: true,
						onClick: e => formElementChanged(e, "question2"),
					}}
					className=" pb-2 text-green"
				/>

				{globalState.question2 === "i" && (
					<>
						<textarea
							name="question2Other"
							maxLength={99}
							required
							className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2"
							onChange={e => formElementChanged(e, "question2Other")}
						></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionTwo
